import type { AppVersionPolicy } from './versionPolicy';
import { APP_VERSION_POLICY as iBlastVersionPolicy } from '../iBlast/appConfig';
import { APP_VERSION_POLICY as iCMUWallVersionPolicy } from '../iCMUWall/appConfig';
import { APP_VERSION_POLICY as iCPVVersionPolicy } from '../iCPV/appConfig';
import { APP_VERSION_POLICY as iConcreteElementVersionPolicy } from '../iConcreteElement/appConfig';
import { APP_VERSION_POLICY as iKRDiagramVersionPolicy } from '../iKRDiagram/appConfig';
import { APP_VERSION_POLICY as iMetalDeckVersionPolicy } from '../iMetalDeck/appConfig';
import { APP_VERSION_POLICY as iMetalStudVersionPolicy } from '../iMetalStud/appConfig';
import { APP_VERSION_POLICY as iPIDiagramVersionPolicy } from '../iPIDiagram/appConfig';
import { APP_VERSION_POLICY as iQuickCalcVersionPolicy } from '../iQuickCalc/appConfig';
import { APP_VERSION_POLICY as iSDOFSolverVersionPolicy } from '../iSDOFSolver/appConfig';
import { APP_VERSION_POLICY as iSecondaryFragmentsVersionPolicy } from '../iSecondaryFragments/appConfig';
import { APP_VERSION_POLICY as iFragmentTrajectoryVersionPolicy } from '../iFragmentTrajectory/appConfig';
import { APP_VERSION_POLICY as iSteelElementVersionPolicy } from '../iSteelElement/appConfig';
import { APP_VERSION_POLICY as iSteelPlateVersionPolicy } from '../iSteelPlate/appConfig';
import { APP_VERSION_POLICY as iVCEBlastVersionPolicy } from '../iVCEBlast/appConfig';
import { APP_VERSION_POLICY as iVentedBlastVersionPolicy } from '../iVentedBlast/appConfig';

// CalcPad cannot discover page versions from IndexedDB alone: saved records only
// contain the version they were created with. This registry gives CalcPad the
// current version policy for each app by importing the app's appConfig module.
//
// The object keys must match SavedPage.appName exactly, because CalcPad uses the
// saved appName to choose which policy to compare against.
export const APP_VERSION_POLICIES: Record<string, AppVersionPolicy> = {
  iBlast: iBlastVersionPolicy,
  iCMUWall: iCMUWallVersionPolicy,
  iCPV: iCPVVersionPolicy,
  iConcreteElement: iConcreteElementVersionPolicy,
  iKRDiagram: iKRDiagramVersionPolicy,
  iMetalDeck: iMetalDeckVersionPolicy,
  iMetalStud: iMetalStudVersionPolicy,
  iPIDiagram: iPIDiagramVersionPolicy,
  iQuickCalc: iQuickCalcVersionPolicy,
  iSDOFSolver: iSDOFSolverVersionPolicy,
  iSecondaryFragments: iSecondaryFragmentsVersionPolicy,
  iFragmentTrajectory: iFragmentTrajectoryVersionPolicy,
  iSteelElement: iSteelElementVersionPolicy,
  iSteelPlate: iSteelPlateVersionPolicy,
  iVCEBlast: iVCEBlastVersionPolicy,
  iVentedBlast: iVentedBlastVersionPolicy
};

// Helper for callers that need null instead of undefined when an app has no
// registered version policy, such as legacy or imported records.
export function getAppVersionPolicy(appName: string): AppVersionPolicy | null {
  return APP_VERSION_POLICIES[appName] ?? null;
}
